import Controller from "./corporateInvoice.controller";
import template from "./corporateInvoice.html";

const corporateInvoice = {
  template,
  controller: Controller,
};

export default corporateInvoice;



// WEBPACK FOOTER //
// ./src/pages/corporateInvoice/corporateInvoice.component.js